// Chapter 6: reports. The guide writes a report field by field and saves it,
// shows its PDF as a preview only (training mode offers no download or print,
// see Components/ExportPDF/pdfPreview.js), then opens a report whose delete
// confirmation is opened and cancelled.
const reports = {
  id: "journey-reports",
  title: "التقارير",
  route: "/reports",
  requires: null,
  steps: [
    {
      target: "reports-search",
      mood: "point",
      title: "البحث",
      body: "لاحظ حقل البحث: يفلتر التقارير بالعنوان أو بالكاتب.",
    },
    {
      target: "reports-table",
      mood: "point",
      title: "قائمة التقارير",
      body: "كل صف تقرير، والضغط على عنوان العمود يرتّب القائمة.",
    },
    {
      target: "reports-add",
      requires: "reports.create",
      mood: "point",
      title: "تقرير جديد",
      body: "سأفتح نموذج تقرير جديد وأكتبه أمامك.",
      action: { type: "click", target: "reports-add" },
    },
    {
      target: "report-stitle",
      requires: "reports.create",
      mood: "explain",
      title: "عنوان التقرير",
      body: "أبدأ بعنوان قصير يصف النشاط.",
      action: { type: "type", target: "report-stitle", value: "زيارة تعليمية للمكتبة" },
    },
    {
      target: "report-tags",
      requires: "reports.create",
      mood: "explain",
      title: "عنوان ثانوي",
      body: "أكتب جزءًا من العنوان الثانوي لتظهر الاقتراحات.",
      action: { type: "type", target: "report-tags", value: "فعاليات" },
    },
    {
      target: "report-tag-option",
      requires: "reports.create",
      mood: "point",
      title: "اختيار الاقتراح",
      body: "سأختار الاقتراح، ويمكنك إضافة أكثر من عنوان.",
      action: { type: "click", target: "report-tag-option" },
    },
    {
      target: "report-info",
      requires: "reports.create",
      mood: "explain",
      title: "صلب الموضوع",
      body: "أكتب هنا ما جرى في النشاط، وهو حقل مطلوب.",
      action: { type: "type", target: "report-info", value: "زار الطلاب مكتبة الحي، وتعرّفوا على طريقة استعارة الكتب." },
    },
    {
      target: "report-save",
      requires: "reports.create",
      mood: "point",
      title: "حفظ التقرير",
      body: "سأضغط «إضافة التقرير» ثم أؤكد الإنشاء.",
      action: { type: "click", target: "report-save" },
    },
    {
      target: "confirm-ok",
      requires: "reports.create",
      mood: "point",
      title: "تأكيد الإنشاء",
      body: "سأضغط «نعم»، فيظهر التقرير في القائمة.",
      action: { type: "click", target: "confirm-ok" },
    },
    {
      target: "reports-pdf",
      mood: "point",
      title: "تصدير PDF",
      body: "سأعرض التقرير كملف PDF للمعاينة بلا تنزيل.",
      action: { type: "click", target: "reports-pdf" },
    },
    {
      target: null,
      mood: "explain",
      title: "تجهيز المعاينة",
      body: "تجهيز الملف يستغرق لحظات، وسأنتظر المعاينة.",
      action: { type: "wait", ms: 1500 },
    },
    {
      target: "pdf-preview-close",
      mood: "point",
      title: "معاينة الملف",
      body: "هكذا يبدو التقرير مطبوعًا. سأغلق المعاينة الآن.",
      action: { type: "click", target: "pdf-preview-close" },
    },
    {
      target: "reports-open",
      mood: "point",
      title: "فتح تقرير",
      body: "سأفتح تقريرًا موجودًا لترى أزرار التعديل والحذف.",
      action: { type: "click", target: "reports-open" },
    },
    {
      target: "report-delete",
      requires: "reports.delete",
      mood: "warn",
      title: "حذف التقرير",
      body: "حذف التقرير نهائي، وسأعرض نافذة التأكيد فقط.",
      action: { type: "click", target: "report-delete" },
    },
    {
      target: "confirm-cancel",
      requires: "reports.delete",
      mood: "explain",
      title: "إلغاء الحذف",
      body: "سأضغط «إلغاء» فيبقى التقرير كما هو.",
      action: { type: "cancelConfirm" },
    },
  ],
};

export default reports;
